import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'login';

const logout = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "logout" , data: params}, callback);
const login = (settings, params, callback) => generateRequest(END_POINT, settings, {action: "process" , data: params}, callback);

const apiEndpoint = {
  logout,
  login
}

export default apiEndpoint;